import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const setTelemedicineProviderDetails = (details) => {
  return {
    type: actionTypes.SET_TELEMEDICINE_PROVIDER_DETAILS,
    payload: details,
  };
};
export const fetchTelemedicineProviderDetailsFailed = (error) => {
  return {
    type: actionTypes.FETCH_TELEMEDICINE_PROVIDER_DETAILS_FAILED,
    error: error,
  };
};
export const fetchTelemedicineProviderDetails = (userId: string) => {
  return (dispatch) => {
    axios
      .get(serverconfigs.fetchTelemedicineUrl+"/" + userId)
      .then((response) => {
        dispatch(setTelemedicineProviderDetails(response.data));
      })
      .catch((error) => {
        console.log("telemedicine", error);
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchTelemedicineProviderDetailsFailed(error));
      });
  };
};
